import {
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation
} from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import {
    getListingPrice
} from '../../../helpers/price.helper';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { FeeCalculationFacade } from '../../../state/fee-calculation/fee-calculation.facade';
import { UserFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';
@Component({
    selector: 'property-summary-page-summary-section',
    templateUrl: './summary-page-summary-section.component.html',
    styleUrls: ['./summary-page-summary-section.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SummaryPageSummarySectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    memberSummary = this._userFacade.memberSummary$;
    memberBalance: number;
    private _destroyed$: Subject<void> = new Subject<void>();
    listingPrice: number | null;
    packagePrice: number;

    constructor(
        draftFacade: DraftFacade,
        private _userFacade: UserFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _feeCalculationFacade: FeeCalculationFacade
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.listingPrice = getListingPrice(
                this.categoryId,
                this.draftData,
                this.metadata
            );

            this._changeDetectorRef.markForCheck();
        });

        this._userFacade.memberSummary$
            .pipe(
                takeUntil(this._destroyed$),
                filter((memberSummary) => !!memberSummary)
            )
            .subscribe((memberSummary) => {
                this.memberBalance = memberSummary.balance;
                this._changeDetectorRef.markForCheck();
            });
        this._feeCalculationFacade.totalFee$
            .pipe(
                takeUntil(this._destroyed$)
            )
            .subscribe((totalFee) => {
                this.packagePrice = totalFee;
                this._changeDetectorRef.markForCheck();
            });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
